import {
  Stack,
  SliderProps as MuiSliderProps,
  Slider as MuiSlider,
} from "@mui/material";
import React from "react";
import Typography from "../Typography";

type SliderProps = MuiSliderProps & {
  title?: string;
  labelstart?: string;
  labelend?: string;
};

const Slider = (props: React.PropsWithChildren<SliderProps>) => {
  const { title, labelstart, labelend, disabled } = props;
  return (
    <Stack
      spacing={0}
      direction="column"
      sx={{
        flexGrow: 1,
        alignItems: "center",
        paddingX: 1,
      }}
    >
      {title && (
        <Typography
          sx={{
            color: ({ palette }) => palette.common.grey.gBFBFBF,
            width: "100%",
            textAlign: "left",
          }}
          size="smaller"
        >
          {title}
        </Typography>
      )}
      <Stack
        spacing={1}
        direction="row"
        sx={{
          alignItems: "flex-start",
          justifyContent: "space-between",
          width: "100%",
          paddingTop: "10px",
        }}
      >
        <Typography color={disabled ? "darkgrey" : "white"} size="smaller">
          {labelstart}
        </Typography>
        <Typography color={disabled ? "darkgrey" : "white"} size="smaller">
          {labelend}
        </Typography>
      </Stack>

      <MuiSlider
        valueLabelDisplay="off"
        size="small"
        sx={{
          paddingTop: "3px",
          "& .MuiSlider-thumb": {
            "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
              boxShadow: "0 0 1px 1px currentColor",
            },
          },
        }}
        {...props}
      />
    </Stack>
  );
};

export default Slider;
